module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible && _vm.records.length),
      expression: "visible && records.length"
    }],
    staticClass: "recent-records"
  }, [_c('h5', {
    staticClass: "recent-records-title"
  }, [_vm._v("Recently viewed")]), _vm._v(" "), _c('ul', {
    staticClass: "recent-records-list"
  }, _vm._l((_vm.records), function(record) {
    return _c('li', {
      key: ((record.type) + "-" + (record.id)),
      staticClass: "recent-records-row",
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.goTo(record)
        }
      }
    }, [_c('span', {
      staticClass: "recent-records-type"
    }, [_vm._v(_vm._s(_vm.typeLabel(record.type)))]), _vm._v(" "), _c('span', {
      staticClass: "recent-records-label"
    }, [_vm._v(_vm._s(_vm.displayLabel(record)))]), _vm._v(" "), _c('span', {
      staticClass: "recent-records-time"
    }, [_vm._v(_vm._s(_vm.formatViewedAt(record.viewedAt)))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83662f16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecentRecords.vue
// module id = 2186
// module chunks = 1